// extracted by mini-css-extract-plugin
export default {"custom-products-slider":"CustomSlider_custom-products-slider__k2Rl1","active-custom-slider":"CustomSlider_active-custom-slider__-M+DP"};